
export const solutions = {
  '1gb.solutions': '1Gb Lösungen',
  '10gb.solutions': '10Gb Lösungen',
  '1gb.vpx.accessories': '1Gb VPX Zubehör',
  'software': 'Software',
  '1gb.description': 'Leistungsstarke 1Gb AV over IP-Lösungen',
  '10gb.description': 'Ultra-leistungsstarke 10Gb AV over IP-Lösungen',
  'vpx.accessories.description': 'Wesentliches Zubehör für 1Gb VPX-Lösungen',
  'software.description': 'Die Aurora IPBaseT Manager-Software ist eine All-in-One-Steuerungsanwendung für die IPX-, VPX- und VLX-Serien von Aurora IPBaseT AV over IP-Produkten',
  'avoip.solutions': 'AVOIP-Lösungen',
  'choose.network.speed': 'Wählen Sie Ihre bevorzugte Netzwerkgeschwindigkeit',
  'touch.controllers': 'Touch-Controller',
  'touch.controllers.description': 'Professionelle Touchpanel-Schnittstellen für nahtlose Steuerung',
  'control.processors': 'Steuerungsprozessoren',
  'control.processors.description': 'Fortschrittliche Steuerungsprozessoren für die Systemverwaltung',
  'reax.software': 'Software',
  'reax.software.description': 'Professionelle Steuerungssystem-Entwicklungssoftware',
  'reax.accessories': 'Zubehör',
  'reax.accessories.description': 'Wesentliches Zubehör für ReAX-Systeme',
  'reax.control.solutions': 'ReAX Steuerungslösungen',
  'choose.control.solution': 'Wählen Sie Ihre bevorzugte Steuerungslösung',
  'digital.signal.processors': 'Digitale Signalprozessoren',
  'dsps.description': 'Professionelle Audioverarbeitungslösungen',
  'amplifiers': 'Verstärker',
  'amplifiers.description': 'Hochleistungs-Audioverstärkung',
  'speakers': 'Lautsprecher',
  'speakers.description': 'Premium-Audiowiedergabelösungen',
  'audio.solutions': 'Audio-Lösungen',
  'choose.audio.solution': 'Wählen Sie Ihre bevorzugte Audio-Lösung',
};
